import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} — BREACH` : 'BREACH — BD Intelligence';
    return () => { document.title = 'BREACH — BD Intelligence'; };
  }, [title]);
};

export default usePageTitle;
